export var combineRefs = function () {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) refs[_key] = arguments[_key];
  return function (node) {
    refs.forEach(function (ref) {
      ref && ("function" != typeof ref ? ref.current = node : ref(node));
    });
  };
};